import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Report from '../../../../common/components/Report';
import {
  getData,
  getColumns,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ReceptacleEventIrregularitiesSelectors';

export function ReceptacleEventIrregularitiesContainer(props) {
  return (
    <Report
      reportId={ReportDefinitions.RECEPTACLE_EVENT_IRREGULARITIES.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state, props) {
  return {
    data: getData(state, props),
    generatedDateTime: getGeneratedOnDateTime(state, props),
    isLoading: getIsLoading(state, props),
    columns: getColumns(state, props),
  };
}

ReceptacleEventIrregularitiesContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ReceptacleEventIrregularitiesContainer);

